"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapCategory;
var _getAttribute = _interopRequireDefault(require("../getAttribute"));
var _rootCategory = require("../rootCategory");
function mapCategory(response) {
  var isFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var getUrl = arguments.length > 3 ? arguments[3] : undefined;
  var isForMenu = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var addSubcategory = function addSubcategory(subcategories, path, isFirst) {
    var subcategory = subcategories.map(function (category) {
      return createCategory(category, false, path);
    }).filter(function (category) {
      return category !== undefined;
    });
    if (subcategory.length === 0) {
      return [];
    }
    return isFirst && response.children_data.length ? [subcategory] : subcategory;
  };
  var mapImage = function mapImage(category) {
    if (global.__appConfig__.categoryImageEnabled && category.image != null && category.image[0].src) {
      category.image[0].src = category.image[0].src.replace(global.__appConfig__.svgImgUrl, "");
      return {
        altText: category.name,
        originalSrc: category.image[0].src,
        variants: [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: category.image[0].src,
            w: category.image[0].width,
            h: category.image[0].height
          }]
        }]
      };
    }
    if (!category.extension_attributes || !category.extension_attributes.image_dimensions) return {};
    var imageDimensions = category.extension_attributes.image_dimensions;
    return {
      altText: category.name,
      originalSrc: imageDimensions[0].src,
      variants: [{
        name: "natural",
        aspectRatio: imageDimensions ? imageDimensions[0].width / imageDimensions[0].height : 1,
        srcset: [{
          url: imageDimensions[0].src,
          w: imageDimensions[0].width,
          h: imageDimensions[0].height
        }]
      }]
    };
  };
  var createUrl = function createUrl(category) {
    return category.special_url ? category.special_url : category.url_path ? category.url_path : getUrl("category-page", {
      id: category.id
    }).as;
  };
  var mapUrl = function mapUrl(url) {
    var _url$find;
    return (_url$find = url.find(function (attribute) {
      if (attribute.attribute_code === "url_path") {
        return attribute.value;
      }
    })) === null || _url$find === void 0 ? void 0 : _url$find.value;
  };
  var createCategory = function createCategory(response) {
    var isFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (!response || !response.children_data && !response.custom_attributes || isForMenu && !response.include_in_menu) return;
    path = path.concat([response.id]);
    return {
      name: response.name,
      id: response.id,
      level: response.level,
      meta: {
        title: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("meta_title")("value") : null,
        description: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("meta_description")("value") : null
      },
      parentId: response.parent_id,
      theme: response.custom_attributes ? (0, _getAttribute["default"])(response.custom_attributes)("layout_update")("value") : null,
      columnInMenu: response.menu_column ? parseInt(response.menu_column) : 0,
      positionInColumn: response.menu_position ? parseInt(response.menu_position) : 0,
      special: false,
      hasSpecialUrl: response.special_url !== null,
      path: path,
      url: (0, _rootCategory.removeRootCategory)(response.children_data && !response.extension_attributes ? createUrl(response) : mapUrl(response.custom_attributes)),
      subcategories: response.custom_attributes ? [] : addSubcategory(response.children_data, path, isFirst),
      image: mapImage(response)
    };
  };
  return createCategory(response, isFirst, path);
}